<template>
  <div id="modal-page-outer">
    <div @click="doClose" id="modal-page-bg"></div>

    <div id="modal-page">
      <button @click="doClose" 
        class="modal-page-close"
        title="Close"
      >
        <X />
      </button>

      <header v-if="hasHeader">
        <slot name="header"></slot>
      </header>
      <main>
        <slot></slot>
      </main>
      <footer v-if="hasFooter">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
import X from "@/components/icons/X";

export default {
  name: "ModalPage",
  components: {
    X,
  },
  methods: {
    doClose() {
      this.$emit("close");
    },
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header;
    },
    hasFooter() {
      return !!this.$slots.footer;
    },
  },
};
</script>
<style>
#modal-page-outer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Calendar z-index values ~ 50 - 150 */
}

#modal-page-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

#modal-page {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 350px;
  height: clamp(350px, 50%, 1000px);
  width: clamp(350px, 80%, 800px);
  border-radius: 5px;
}

#modal-page .modal-page-close {
  position: absolute;
  top: 0;
  right: 8px;
  border: none;
  cursor: pointer;
  color: #333;
  background: transparent;
  padding: 0;
}
#modal-page .modal-page-close svg {
  height: 30px;
  width: 30px;
}

#modal-page header {
    padding: 10px 10px 0 10px;
}
#modal-page main {
    flex-grow: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
}
#modal-page footer {
    background-color: #eee;
    padding: 10px 20px;
}
</style>